import React, { useState } from 'react';
import PageContainerAB from '@/components/PageContainerAB/pageContainer';
import PageContainerTabs from '@/components/PageContainerTabs';
import AppointmentReportTab from './AppointmentReportTab';
import RedeliveryReportTab from './RedeliveryReportTab';

// PageContainerTabs uses row-reverse — last item renders leftmost (first tab).
const REPORT_TAB_ITEMS = [
  {
    title: 'Redelivery',
    pushAddress: 'redelivery',
    width: 'fit-content',
  },
  {
    title: 'Overview',
    pushAddress: 'overview',
    width: 'fit-content',
  },
];

const Report = () => {
  const [activeTab, setActiveTab] = useState('overview');

  return (
    <PageContainerAB
      minWidth="unset"
      title="Performance Report"
      mainPage={true}
      basePath="/my-appointment">
      <div className="mt-4 mb-6">
        <PageContainerTabs
          skipHistory
          titlesLinks={REPORT_TAB_ITEMS}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          baseAddress="/report/"
        />
      </div>
      {activeTab === 'redelivery' ? (
        <RedeliveryReportTab />
      ) : (
        <AppointmentReportTab />
      )}
    </PageContainerAB>
  );
};

export default Report;
